import type { TranslationTemplate } from "../../../application.i18n";

export default {
	status: {
		"400": {
			title: "400 Ugyldig forespørsel",
			description: "Serveren kunne ikke forstå forespørselen på grunn av ugyldig syntaks eller data.",
		},
		"401": {
			title: "401 Uautorisert",
			description: "Du er ikke autorisert til å bruke denne ressursen. Du må oppgi gyldige påloggingsdetaljer for å få tilgang.",
		},
		"403": {
			title: "403 Forbudt",
			description: "Du er autentisert, men du har ikke tillatelse til å utføre denne handlingen.",
		},
		"404": {
			title: "404 Ikke funnet",
			description: "Det forespurte endepunktet eller ressursen eksisterer ikke.",
		},
		"405": {
			title: "405 Metode ikke tillatt",
			description: "Endepunktet støtter ikke HTTP-metoden du bruker (f.eks. POST på et endepunkt som kun tillater GET).",
		},
		"408": {
			title: "408 Forespørsel tidsavbrutt",
			description: "Forespørselen din tok for lang tid å sende eller fullføre.",
		},
		"409": {
			title: "409 Konflikt",
			description: "Forespørselen kan ikke fullføres på grunn av en konflikt med ressursversjonen eller duplikat oppføring.",
		},
		"413": {
			title: "413 Last for stor",
			description: "Den opplastede filen eller forespørselsdataene overstiger serverens grenser.",
		},
		"429": {
			title: "429 For mange forespørsler",
			description: "Du har sendt for mange forespørsler på kort tid. Vennligst vent litt.",
		},
		"500": {
			title: "Intern serverfeil",
			description: "Serveren støtte på en feil den ikke kunne håndtere.",
		},
		"501": {
			title: "501 Ikke implementert",
			description: "Serveren støtter ikke funksjonaliteten som kreves.",
		},
		"502": {
			title: "502 Ugyldig gateway",
			description: "Serveren fungerte som en gateway og mottok et ugyldig svar.",
		},
		"503": {
			title: "Tjeneste utilgjengelig",
			description: "APIet er midlertidig utilgjengelig (vedlikehold eller høy belastning).",
		},
		"504": {
			title: "504 Gateway tidsavbrutt",
			description: "Serveren fungerte som en gateway og mottok ikke et svar i tide.",
		},
	},
} satisfies TranslationTemplate["ERROR"];
